import IContentDeliveryAPI from './IContentDeliveryAPI.js';
import IAuthStorage from './IAuthStorage.js';
import IAuthService, { IAuthEvents, IAuthServiceStatic, IOAuthResponseIsSuccess } from './IAuthService.js';
import IAuthTokenProvider, { IAuthToken } from './IAuthTokenProvider.js';
import BrowserAuthStorage from './BrowserAuthStorage.js';
import EventEmitter from 'eventemitter3';

class DefaultAuthServiceCls extends EventEmitter<IAuthEvents> implements IAuthService, IAuthTokenProvider {
    private _storage: IAuthStorage
    private _api: IContentDeliveryAPI

    constructor(api: IContentDeliveryAPI, storage?: IAuthStorage) {
        super();
        this._storage = storage || new BrowserAuthStorage();
        this._api = api;
        api.TokenProvider = this;
    }

    public async getCurrentToken(): Promise<IAuthToken | undefined> {
        if (await this.isAuthenticated().catch(() => false)) {
            const currentToken = this._storage.getToken();
            return currentToken ? { access_token: currentToken.access_token || '', token_type: currentToken.token_type || '', username: currentToken.username || '' } : undefined;
        }
        return undefined;
    }

    public ping(): Promise<void> {
        return this.isAuthenticated().then(x => { return; })
    }

    public currentUser(): Promise<string | null> {
        const token = this._storage.getToken();
        return Promise.resolve(token ? token.username || '' : null);
    }

    public async login(username: string, password: string, client_id: string, client_secret: string): Promise<boolean> {
        const resp = await this._api.login(username, password, client_id, client_secret);
        return IOAuthResponseIsSuccess(resp) && this._storage.storeToken(resp);
    }

    public logout(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            try {
                resolve(this._storage.clearToken());
            } catch (e) {
                reject(e);
            }
        });
    }

    public isAuthenticated(): Promise<boolean> {
        //return Promise.resolve(true);
        if (!this._api.OnLine) return Promise.resolve(this._storage.hasToken()); // If we're offline assume that we could refresh the token if desired
        const token = this._storage.getToken();
        const date = parseInt(token ? token['.expires'] || '0' : '0')
        if (!token) return Promise.resolve(false);
        if (date >= Date.now()) {
            return Promise.resolve(true);
        }
        return Promise.resolve(false);
        /*return this._api.refreshToken(token.refresh_token).then(r => IOAuthResponseIsSuccess(r) && this._storage.storeToken(r)).catch(() => false).then(auth => {
            if (!auth) this._storage.clearToken();
            return auth;
        });*/
    }
}

// Export fully type-checked for both static and instance type
export const DefaultAuthService: IAuthServiceStatic = DefaultAuthServiceCls;
export default DefaultAuthService;